import React from "react";
import "./NavBarStyle.css";
import { Link } from "react-router-dom";

const NavBar = () => {
  return (
    <div className="NavBar">
      <div className="Title">
        <Link to="/">
          {/* ⚠️语言 StrideWorld */}
          <h1>跑遍世界</h1>
        </Link>
        {/* 语言切换功能 */}
        {/* <LanguageButton/> */}
      </div>

      <div className="nav-menu">
        <ul>
          <li>
            {/* ⚠️语言 */}
            <Link to="/">首页</Link>
          </li>
          <li>
            {/* ⚠️语言 */}
            <Link to="/Contact">联系我</Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NavBar;
